import type { Movie } from "@/types/content";

export const movies: Movie[] = [
  {
    id: "back-to-the-future",
    title: "回到未来",
    originalTitle: "Back to the Future",
    year: 1985,
    genres: ["科幻", "冒险"],
    director: "罗伯特·泽米吉斯",
    cast: ["迈克尔·J·福克斯", "克里斯托弗·洛伊德", "莉·汤普森"],
    runtime: 116,
    rating: 9.1,
    poster:
      "https://readdy.ai/api/search-image?query=Retro%201980s%20science%20fiction%20movie%20poster%20illustration%20of%20a%20silver%20sports%20car%20with%20glowing%20time%20circuits%20racing%20through%20streaks%20of%20light%2C%20dramatic%20low%20angle%2C%20painted%20vintage%20poster%20art%2C%20warm%20burgundy%20gold%20and%20cream%20palette%2C%20subtle%20film%20grain%2C%20cinematic%20lighting%2C%20no%20text%20no%20lettering&width=600&height=800&seq=poster-bttf-85&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20retro%20science%20fiction%20scene%20of%20an%20empty%20American%20suburban%20street%20at%20dusk%20with%20a%20gleaming%20silver%20sports%20car%20and%20glowing%20light%20trails%2C%20warm%20amber%20streetlights%2C%20stylized%20painted%20illustration%2C%201980s%20film%20grain%2C%20rich%20burgundy%20and%20gold%20tones%2C%20moody%20atmosphere%2C%20no%20text&width=1600&height=760&seq=hero-bttf-85&orientation=landscape",
    tagline: "他把未来开回了 1955 年。",
    synopsis:
      "高中生马蒂·麦克弗莱在一次意外的实验中，驾驶着布朗博士改装的德罗宁跑车穿越回 1955 年。他必须在改变历史之前，让年轻的父母重新相爱，并找到回到 1985 年的方法。这是一部把时间悖论、青春期焦虑与美式小镇温情缝合得毫无缝隙的冒险喜剧。",
    reviewSnippet:
      "三十多年过去，那辆德罗宁依然是最浪漫的时间机器——它证明青春最大的冒险，是想办法让父母的青春重新开始。",
    reviewAuthor: "沈墨白",
    popularity: 98,
    featured: true,
  },
  {
    id: "blade-runner",
    title: "银翼杀手",
    originalTitle: "Blade Runner",
    year: 1982,
    genres: ["科幻", "剧情"],
    director: "雷德利·斯科特",
    cast: ["哈里森·福特", "鲁特格尔·哈尔", "肖恩·杨"],
    runtime: 117,
    rating: 8.9,
    poster:
      "https://readdy.ai/api/search-image?query=Retro%20cyberpunk%20noir%20movie%20poster%20illustration%20of%20a%20rain%20soaked%20future%20city%20with%20giant%20neon%20signs%2C%20a%20lone%20trench%20coat%20figure%20seen%20from%20behind%2C%20painted%20vintage%20poster%20art%2C%20amber%20and%20burgundy%20glow%2C%20dense%20atmosphere%2C%20film%20grain%2C%20no%20text%20no%20lettering&width=600&height=800&seq=poster-bladerunner-82&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Rain%20drenched%20futuristic%20city%20skyline%20at%20night%20with%20warm%20amber%20and%20deep%20red%20neon%20reflections%20on%20wet%20streets%2C%20volumetric%20fog%2C%20cyberpunk%20noir%20cinematography%2C%20painted%20retro%20illustration%20style%2C%201980s%20film%20grain%2C%20no%20text&width=1600&height=760&seq=hero-bladerunner-82&orientation=landscape",
    tagline: "人造的梦，也会梦见羊吗？",
    synopsis:
      "2019 年的洛杉矶，阴雨、霓虹与酸雨构成了城市的日常。退休的银翼杀手瑞克·德卡德被重新召回，追捕四名叛逃的复制人。然而当他在追捕中逐渐理解这些「人造生命」对存在的渴望，人与复制人的界线开始崩塌。",
    reviewSnippet:
      "它当年票房失利，却用一场雨中的独白，替整个八十年代科幻留下了最像诗的注脚。",
    reviewAuthor: "林知远",
    popularity: 95,
    featured: true,
  },
  {
    id: "the-shining",
    title: "闪灵",
    originalTitle: "The Shining",
    year: 1980,
    genres: ["恐怖", "剧情"],
    director: "斯坦利·库布里克",
    cast: ["杰克·尼科尔森", "谢莉·杜瓦尔", "丹尼·劳埃德"],
    runtime: 146,
    rating: 8.5,
    poster:
      "https://readdy.ai/api/search-image?query=Retro%20psychological%20horror%20movie%20poster%20illustration%20of%20an%20endless%20hotel%20corridor%20with%20patterned%20red%20carpet%20and%20golden%20wall%20lamps%2C%20a%20tiny%20distant%20figure%2C%20symmetrical%20one%20point%20perspective%2C%20painted%20vintage%20poster%20art%2C%20cream%20and%20burgundy%20palette%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=poster-shining-80&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Symmetrical%20grand%20hotel%20lobby%20in%20the%201980s%20with%20geometric%20red%20carpet%2C%20warm%20golden%20lamplight%20and%20long%20empty%20corridors%2C%20eerie%20quiet%20atmosphere%2C%20stylized%20painted%20cinematic%20illustration%2C%20film%20grain%2C%20burgundy%20cream%20and%20gold%20tones%2C%20no%20text&width=1600&height=760&seq=hero-shining-80&orientation=landscape",
    tagline: "雪季封山，酒店里只剩一家人。",
    synopsis:
      "作家杰克带着妻子与拥有「闪灵」能力的儿子入住冬季封闭的远望酒店，担任看守人。空旷的走廊、237 号房与不断涌出的幻象逐渐侵蚀他的理智。库布里克用几何构图与压迫性的音效，把父权暴力拍成了一场无法醒来的噩梦。",
    reviewSnippet:
      "真正的恐怖不是血，而是那条永远走不到尽头的走廊，以及走廊尽头那个你熟悉到不敢认的父亲。",
    reviewAuthor: "周迟",
    popularity: 93,
    featured: true,
  },
  {
    id: "top-gun",
    title: "壮志凌云",
    originalTitle: "Top Gun",
    year: 1986,
    genres: ["动作", "剧情"],
    director: "托尼·斯科特",
    cast: ["汤姆·克鲁斯", "凯莉·麦吉利斯", "方·基默"],
    runtime: 110,
    rating: 8.2,
    poster:
      "https://readdy.ai/api/search-image?query=Retro%201980s%20action%20movie%20poster%20illustration%20of%20a%20fighter%20jet%20climbing%20through%20a%20burning%20orange%20sunset%20sky%20with%20dramatic%20clouds%2C%20pilot%20helmet%20silhouette%20in%20the%20foreground%2C%20painted%20vintage%20poster%20art%2C%20warm%20gold%20and%20burgundy%20palette%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=poster-topgun-86&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Fighter%20jets%20flying%20in%20formation%20above%20golden%20clouds%20at%20sunset%20over%20the%20ocean%2C%20glowing%20amber%20horizon%2C%20dramatic%20aerial%20cinematography%2C%20painted%20retro%20illustration%20style%2C%201980s%20film%20grain%2C%20warm%20burgundy%20and%20gold%20tones%2C%20no%20text&width=1600&height=760&seq=hero-topgun-86&orientation=landscape",
    tagline: "在云层之上，速度就是一切。",
    synopsis:
      "海军飞行员麦德林被选入顶尖飞行学校受训，在教官与同僚之间反复证明自己。空战的轰鸣、排球场上的阳光与酒吧里的钢琴，共同构成了八十年代最成功的一次「商业片美学」示范。",
    reviewSnippet:
      "它把招募广告拍成了青春片：引擎的嘶吼、汗湿的飞行夹克，还有一个不肯承认自己害怕的年轻人。",
    reviewAuthor: "高远",
    popularity: 90,
  },
  {
    id: "dead-poets-society",
    title: "死亡诗社",
    originalTitle: "Dead Poets Society",
    year: 1989,
    genres: ["剧情"],
    director: "彼得·威尔",
    cast: ["罗宾·威廉姆斯", "伊桑·霍克", "罗伯特·肖恩·莱纳德"],
    runtime: 128,
    rating: 9.0,
    poster:
      "https://readdy.ai/api/search-image?query=Retro%20coming%20of%20age%20drama%20movie%20poster%20illustration%20of%20a%20candlelit%20old%20school%20classroom%20with%20tall%20arched%20windows%20and%20autumn%20leaves%20outside%2C%20silhouettes%20of%20young%20students%2C%20painted%20vintage%20poster%20art%2C%20amber%20gold%20and%20burgundy%20palette%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=poster-deadpoets-89&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Autumn%20New%20England%20boarding%20school%20campus%20with%20golden%20maple%20trees%2C%20stone%20arches%20and%20soft%20morning%20mist%2C%20students%20walking%20in%20the%20distance%2C%20painted%20retro%20cinematic%20illustration%2C%201980s%20film%20grain%2C%20warm%20amber%20and%20cream%20tones%2C%20no%20text&width=1600&height=760&seq=hero-deadpoets-89&orientation=landscape",
    tagline: "把握今天，让生活不同凡响。",
    synopsis:
      "1959 年，新来的英语老师基廷用诗与站上课桌的方式，唤醒了威尔顿预备学院一群循规蹈矩的少年。他们重组「死亡诗社」，在洞穴里读诗、在舞台上演出，也第一次撞上了体制与家庭的铜墙铁壁。",
    reviewSnippet:
      "它没有给出答案，只递给每个观众一张课桌：你要不要站上去，换一个角度看世界？",
    reviewAuthor: "沈墨白",
    popularity: 92,
  },
  {
    id: "the-breakfast-club",
    title: "早餐俱乐部",
    originalTitle: "The Breakfast Club",
    year: 1985,
    genres: ["喜剧", "剧情"],
    director: "约翰·休斯",
    cast: ["艾米利奥·艾斯特维兹", "莫利·林沃德", "贾德·尼尔森"],
    runtime: 97,
    rating: 8.3,
    poster:
      "https://readdy.ai/api/search-image?query=Retro%201980s%20teen%20movie%20poster%20illustration%20of%20five%20high%20school%20students%20sitting%20apart%20on%20a%20library%20mezzanine%20with%20warm%20afternoon%20light%2C%20vinyl%20records%20and%20bookshelves%2C%20painted%20vintage%20poster%20art%2C%20burgundy%20gold%20and%20cream%20palette%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=poster-breakfast-85&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Empty%201980s%20high%20school%20library%20with%20tall%20wooden%20shelves%2C%20long%20tables%20and%20warm%20sunlight%20streaming%20through%20blinds%2C%20nostalgic%20quiet%20mood%2C%20painted%20retro%20cinematic%20illustration%2C%20film%20grain%2C%20amber%20and%20burgundy%20tones%2C%20no%20text&width=1600&height=760&seq=hero-breakfast-85&orientation=landscape",
    tagline: "五个陌生人，一个星期六，一间图书馆。",
    synopsis:
      "五个来自不同小圈子的高中生因为周六留校处分被关在同一间图书馆。从互相嘲讽到撕开各自的伪装，他们在一天之内完成了一场关于身份、家庭与孤独的集体告白。",
    reviewSnippet:
      "全片几乎没有离开过一间屋子，却拍出了八十年代青春片最辽阔的一次自我辨认。",
    reviewAuthor: "苏未",
    popularity: 85,
  },
  {
    id: "die-hard",
    title: "虎胆龙威",
    originalTitle: "Die Hard",
    year: 1988,
    genres: ["动作"],
    director: "约翰·麦克蒂尔南",
    cast: ["布鲁斯·威利斯", "艾伦·瑞克曼", "邦妮·比蒂丽娅"],
    runtime: 132,
    rating: 8.7,
    poster:
      "https://readdy.ai/api/search-image?query=Retro%201980s%20action%20thriller%20movie%20poster%20illustration%20of%20a%20towering%20glass%20skyscraper%20at%20night%20with%20one%20lit%20window%2C%20a%20lone%20man%20silhouette%20on%20a%20ventilation%20shaft%2C%20painted%20vintage%20poster%20art%2C%20amber%20and%20deep%20burgundy%20palette%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=poster-diehard-88&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Night%20view%20of%20a%20tall%20glass%20office%20tower%20in%20Los%20Angeles%20with%20warm%20amber%20windows%20and%20city%20lights%20below%2C%20dramatic%20low%20angle%2C%20painted%20retro%20cinematic%20illustration%2C%201980s%20film%20grain%2C%20burgundy%20gold%20tones%2C%20no%20text&width=1600&height=760&seq=hero-diehard-88&orientation=landscape",
    tagline: "他不是超级英雄，他只是不肯让步。",
    synopsis:
      "纽约警察麦卡伦飞到洛杉矶挽回婚姻，却在妻子公司的圣诞晚宴上撞见一伙劫持人质的悍匪。赤脚、满身玻璃渣的他，用最不体面的方式，把「动作英雄」重新定义成了一个会害怕的普通人。",
    reviewSnippet:
      "它最革命的地方，是让主角一路流血、一路抱怨，却始终没有变成刀枪不入的神。",
    reviewAuthor: "高远",
    popularity: 88,
  },
  {
    id: "amadeus",
    title: "莫扎特传",
    originalTitle: "Amadeus",
    year: 1984,
    genres: ["剧情"],
    director: "米洛斯·福尔曼",
    cast: ["F·默里·亚伯拉罕", "汤姆·休斯克", "伊丽莎白·贝里奇"],
    runtime: 160,
    rating: 8.8,
    poster:
      "https://readdy.ai/api/search-image?query=Retro%20period%20drama%20movie%20poster%20illustration%20of%20an%20ornate%2018th%20century%20opera%20house%20with%20candlelight%2C%20red%20velvet%20curtains%20and%20a%20masked%20composer%20silhouette%2C%20painted%20vintage%20poster%20art%2C%20burgundy%20gold%20and%20cream%20palette%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=poster-amadeus-84&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Opulent%20baroque%20opera%20theatre%20interior%20lit%20by%20hundreds%20of%20candles%20with%20deep%20red%20velvet%20seating%20and%20gilded%20balconies%2C%20empty%20stage%2C%20painted%20retro%20cinematic%20illustration%2C%20warm%20gold%20and%20burgundy%20tones%2C%20film%20grain%2C%20no%20text&width=1600&height=760&seq=hero-amadeus-84&orientation=landscape",
    tagline: "上帝为什么把天赋给了那个顽童？",
    synopsis:
      "年迈的宫廷作曲家萨列里向神父忏悔：他一生虔诚，却被一个粗俗、放荡、却才华横溢的莫扎特彻底击溃。福尔曼用华丽的歌剧场面与冷酷的嫉妒，写下一封关于平庸与天才的长信。",
    reviewSnippet:
      "这不是莫扎特的传记，而是一个凡人对天才的漫长凝视——看见光，也被光灼伤。",
    reviewAuthor: "林知远",
    popularity: 80,
  },
  {
    id: "rain-man",
    title: "雨人",
    originalTitle: "Rain Man",
    year: 1988,
    genres: ["剧情"],
    director: "巴里·莱文森",
    cast: ["达斯汀·霍夫曼", "汤姆·克鲁斯", "瓦莱丽亚·戈利诺"],
    runtime: 133,
    rating: 8.6,
    poster:
      "https://readdy.ai/api/search-image?query=Retro%201980s%20road%20movie%20poster%20illustration%20of%20a%20vintage%20cream%20convertible%20driving%20across%20a%20desert%20highway%20at%20golden%20hour%2C%20two%20distant%20figures%2C%20painted%20vintage%20poster%20art%2C%20warm%20amber%20and%20burgundy%20palette%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=poster-rainman-88&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Endless%20American%20desert%20highway%20at%20sunset%20with%20a%20single%20vintage%20car%2C%20golden%20dust%20in%20the%20air%2C%20telephone%20poles%20receding%20into%20the%20horizon%2C%20painted%20retro%20cinematic%20illustration%2C%20warm%20amber%20tones%2C%20film%20grain%2C%20no%20text&width=1600&height=760&seq=hero-rainman-88&orientation=landscape",
    tagline: "他记得每一张牌，却记不住怎么拥抱。",
    synopsis:
      "自私的汽车商人查理在父亲去世后，发现自己有一个患有自闭症的哥哥雷蒙。为了争夺遗产，他带着哥哥踏上横穿美国的公路旅程，也在漫长的相处里，第一次学会照顾另一个人。",
    reviewSnippet:
      "公路片的壳，家庭片的核。它最动人的一刻，是两个成年人终于在同一句话里停住了脚步。",
    reviewAuthor: "苏未",
    popularity: 78,
  },
  {
    id: "e-t",
    title: "E.T. 外星人",
    originalTitle: "E.T. the Extra-Terrestrial",
    year: 1982,
    genres: ["科幻", "冒险"],
    director: "史蒂文·斯皮尔伯格",
    cast: ["亨利·托马斯", "德鲁·巴里摩尔", "迪·沃伦斯"],
    runtime: 115,
    rating: 8.7,
    poster:
      "https://readdy.ai/api/search-image?query=Retro%201980s%20family%20science%20fiction%20movie%20poster%20illustration%20of%20children%20on%20bicycles%20silhouetted%20against%20a%20giant%20golden%20full%20moon%20in%20a%20starry%20night%20sky%2C%20painted%20vintage%20poster%20art%2C%20warm%20amber%20and%20burgundy%20palette%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=poster-et-82&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Night%20forest%20clearing%20with%20a%20giant%20golden%20moon%20and%20soft%20mist%2C%20bicycles%20parked%20on%20a%20hillside%2C%20glowing%20warm%20light%20among%20pine%20trees%2C%20painted%20retro%20cinematic%20illustration%2C%201980s%20film%20grain%2C%20amber%20and%20cream%20tones%2C%20no%20text&width=1600&height=760&seq=hero-et-82&orientation=landscape",
    tagline: "他只想回家。",
    synopsis:
      "十岁的艾略特在郊外的工具棚里发现了一个被遗弃的外星生物。两个孩子与这个怕光、会发光的客人建立起心灵感应，并策划了一场穿越警车与夜空的逃亡。斯皮尔伯格把童年孤独拍成了一次温柔的降落。",
    reviewSnippet:
      "月光下的自行车飞起来的那一刻，电影重新变回了它最原始的样子——让人相信奇迹。",
    reviewAuthor: "周迟",
    popularity: 86,
  },
  {
    id: "when-harry-met-sally",
    title: "当哈利遇到莎莉",
    originalTitle: "When Harry Met Sally...",
    year: 1989,
    genres: ["爱情", "喜剧"],
    director: "罗伯·莱纳",
    cast: ["比利·克里斯托", "梅格·瑞恩", "凯丽·费雪"],
    runtime: 96,
    rating: 8.4,
    poster:
      "https://readdy.ai/api/search-image?query=Retro%201980s%20romantic%20comedy%20movie%20poster%20illustration%20of%20a%20couple%20sitting%20on%20a%20park%20bench%20under%20golden%20autumn%20trees%20in%20New%20York%2C%20warm%20afternoon%20light%2C%20painted%20vintage%20poster%20art%2C%20burgundy%20amber%20and%20cream%20palette%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=poster-harrysally-89&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Central%20Park%20in%20autumn%20with%20golden%20maple%20leaves%2C%20a%20wooden%20bench%20and%20warm%20late%20afternoon%20sunlight%20through%20the%20trees%2C%20New%20York%20skyline%20in%20the%20distance%2C%20painted%20retro%20cinematic%20illustration%2C%20warm%20burgundy%20and%20amber%20tones%2C%20film%20grain%2C%20no%20text&width=1600&height=760&seq=hero-harrysally-89&orientation=landscape",
    tagline: "男女之间，真的不能只是朋友吗？",
    synopsis:
      "哈利与莎莉在十二年间不断相遇、分开、再相遇。从大学时代的争执，到各自经历婚姻失败，他们用一整个八十年代去验证一个古老的问题：异性之间到底能不能只做朋友。",
    reviewSnippet:
      "它把爱情片从「命中注定」拉回了「长期相处」，也因此成了后来三十年所有都市爱情片的标准答案。",
    reviewAuthor: "苏未",
    popularity: 83,
  },
  {
    id: "platoon",
    title: "野战排",
    originalTitle: "Platoon",
    year: 1986,
    genres: ["战争", "剧情"],
    director: "奥利弗·斯通",
    cast: ["查理·辛", "威廉·达福", "汤姆·贝伦杰"],
    runtime: 120,
    rating: 8.1,
    poster:
      "https://readdy.ai/api/search-image?query=Retro%201980s%20war%20drama%20movie%20poster%20illustration%20of%20soldiers%20silhouetted%20in%20a%20dense%20tropical%20jungle%20with%20shafts%20of%20golden%20light%20and%20smoke%2C%20helicopter%20in%20the%20distance%2C%20painted%20vintage%20poster%20art%2C%20burgundy%20amber%20and%20deep%20green%20palette%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=poster-platoon-86&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Hazy%20tropical%20jungle%20canopy%20with%20dramatic%20sunbeams%20cutting%20through%20smoke%2C%20silhouettes%20of%20helicopters%20above%20the%20treeline%2C%20painted%20retro%20cinematic%20illustration%2C%201980s%20film%20grain%2C%20warm%20amber%20and%20deep%20burgundy%20tones%2C%20no%20text&width=1600&height=760&seq=hero-platoon-86&orientation=landscape",
    tagline: "战争里最先失去的，是判断对错的能力。",
    synopsis:
      "年轻的大学生克里斯自愿赴越参战，却被扔进两个价值观完全对立的士官之间。丛林里的每一次巡逻都在消耗人性，而真正让他崩溃的，不是敌人的枪口，而是同伴的选择。",
    reviewSnippet:
      "斯通把自己在越南的经历剖开给观众看：没有荣耀，只有一场关于良知的内部战争。",
    reviewAuthor: "高远",
    popularity: 70,
  },
  {
    id: "aliens",
    title: "异形2",
    originalTitle: "Aliens",
    year: 1986,
    genres: ["科幻", "动作"],
    director: "詹姆斯·卡梅隆",
    cast: ["西格妮·韦弗", "迈克尔·比恩", "兰斯·亨利克森"],
    runtime: 137,
    rating: 8.5,
    poster:
      "https://readdy.ai/api/search-image?query=Retro%201980s%20science%20fiction%20action%20movie%20poster%20illustration%20of%20a%20female%20space%20marine%20in%20armor%20holding%20a%20flamethrower%20inside%20an%20industrial%20space%20station%20corridor%20with%20red%20emergency%20lighting%2C%20painted%20vintage%20poster%20art%2C%20burgundy%20amber%20and%20cream%20palette%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=poster-aliens-86&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Dark%20industrial%20spaceship%20corridor%20with%20steam%20and%20red%20emergency%20lights%2C%20dripping%20condensation%2C%20deep%20shadows%20and%20warm%20amber%20highlights%2C%20painted%20retro%20cinematic%20illustration%2C%201980s%20film%20grain%2C%20no%20text&width=1600&height=760&seq=hero-aliens-86&orientation=landscape",
    tagline: "在太空里，没人能听见你的尖叫。",
    synopsis:
      "在宇宙漂流五十七年后，蕾普莉被救回地球，却被迫再次返回异形肆虐的殖民地。这一次她不再只是逃生者，而是带着陆战队与一台工程机器人，去面对蜂群般的怪物与更可怕的母公司决策。",
    reviewSnippet:
      "卡梅隆把幽闭恐怖换成了战争片节奏，却把「母亲」这个词，留在了全片最柔软也最凶狠的地方。",
    reviewAuthor: "林知远",
    popularity: 87,
  },
  {
    id: "ferris-bueller",
    title: "春天不是读书天",
    originalTitle: "Ferris Bueller's Day Off",
    year: 1986,
    genres: ["喜剧"],
    director: "约翰·休斯",
    cast: ["马修·布罗德里克", "艾伦·卢克", "米娅·萨拉"],
    runtime: 103,
    rating: 8.0,
    poster:
      "https://readdy.ai/api/search-image?query=Retro%201980s%20teen%20comedy%20movie%20poster%20illustration%20of%20a%20red%20vintage%20sports%20car%20speeding%20through%20a%20sunny%20suburban%20street%20with%20a%20teenager%20leaning%20out%2C%20painted%20vintage%20poster%20art%2C%20warm%20amber%20gold%20and%20burgundy%20palette%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=poster-ferris-86&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Sunny%201980s%20Chicago%20suburban%20street%20with%20maple%20trees%2C%20a%20red%20vintage%20sports%20car%20parked%20in%20front%20of%20a%20white%20house%2C%20warm%20golden%20morning%20light%2C%20painted%20retro%20cinematic%20illustration%2C%20film%20grain%2C%20no%20text&width=1600&height=760&seq=hero-ferris-86&orientation=landscape",
    tagline: "人生短暂，偶尔逃课。",
    synopsis:
      "高三学生费里斯不想上学，于是请了病假，拉着好友和女友进城，把芝加哥变成了一整天的游乐场：博物馆、高级餐厅、花车游行，还有一辆被「借」来的法拉利。而教导主任正一路追查他的谎言。",
    reviewSnippet:
      "它像一封写给逃课的长信，认真得离谱，也快乐得离谱——八十年代青春片最会玩的一次。",
    reviewAuthor: "周迟",
    popularity: 72,
  },
  {
    id: "the-terminator",
    title: "终结者",
    originalTitle: "The Terminator",
    year: 1984,
    genres: ["科幻", "动作"],
    director: "詹姆斯·卡梅隆",
    cast: ["阿诺·施瓦辛格", "琳达·汉密尔顿", "迈克尔·比恩"],
    runtime: 107,
    rating: 8.2,
    poster:
      "https://readdy.ai/api/search-image?query=Retro%201980s%20science%20fiction%20thriller%20movie%20poster%20illustration%20of%20a%20muscular%20leather%20jacket%20figure%20lit%20from%20behind%20with%20a%20single%20glowing%20red%20eye%2C%20rain%20and%20smoke%2C%20painted%20vintage%20poster%20art%2C%20deep%20burgundy%20amber%20and%20cream%20palette%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=poster-terminator-84&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Rain%20soaked%20Los%20Angeles%20street%20at%20night%20with%20red%20tail%20lights%20and%20dramatic%20smoke%2C%20a%20lone%20figure%20in%20a%20leather%20jacket%2C%20painted%20retro%20cinematic%20illustration%2C%201980s%20film%20grain%2C%20burgundy%20amber%20tones%2C%20no%20text&width=1600&height=760&seq=hero-terminator-84&orientation=landscape",
    tagline: "来自未来的杀手，不会停下。",
    synopsis:
      "一个来自 2029 年的机械杀手穿越到 1984 年的洛杉矶，目标是杀死未来抵抗军领袖的母亲。而保护她的，是另一名从未来返回的士兵。卡梅隆用极低预算拍出了几乎无法复制的紧迫感。",
    reviewSnippet:
      "它把科幻变成了追车与枪战，也让「我会回来」成为电影史上最冷的一句承诺。",
    reviewAuthor: "高远",
    popularity: 89,
  },
];